import React from "react";
import "./Login.css";
import TextTheme from "components/General/Text/TextTheme";
import CustomInput from "components/General/Form/CustomInput";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import CustomBanner from "components/General/Form/CustomBanner";
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import * as CONSTANT from "constants/text";
import AxiosConfig from "../../../axiosConfig";

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      selectedOption: "",
      emailError: "",
      submitMessage: "",
      selectedOptionError: "",
    };
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption: selectedOption.value });
    this.setState({ selectedOptionError: "" });
  };

  onDataChange = (event) => {
    this.setState({ email: event.target.value });
    this.setState({ emailError: "" });
  };

  validate = () => {
    let flag = true;
    function validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    if (validateEmail(this.state.email)) {
      this.setState({ emailError: "" });
    } else {
      this.setState({ emailError: CONSTANT.INVALID_EMAIL });
      flag = false;
    }

    if (this.state.selectedOption !== "") {
      this.setState({ selectedOptionError: "" });
    } else {
      this.setState({ selectedOptionError: CONSTANT.INVALID_RECOVERY_OPTION });
      flag = false;
    }
    return flag;
  };

  handleSubmit = () => {
    if (this.validate()) {
      let form_data = new FormData();
      form_data.append("email", this.state.email);
      if (this.state.selectedOption === "forgotPassword") {
        this.callForgotAPI("forgot_password", form_data);
      } else {
        this.callForgotAPI("forgot_username", form_data);
      }
    }
  };

  callForgotAPI(apiName, form_data) {
    AxiosConfig.post("account/" + apiName + "/", form_data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((res) => {
        this.setState({
          submitMessage: res.data.message,
        });
      })
      .catch();
  }
  render() {
    const options = [
      { value: "forgotUsername", label: "Forgot Username" },
      { value: "forgotPassword", label: "Forgot Password" },
    ];

    return (
      <div style={{ textAlign: "-webkit-center" }}>
        <CustomBanner message="Account Recovery" />
        {
          <div className="form_register">
            <FormControl
              variant="outlined"
              style={{
                marginLeft: "15%",
                width: "70%",
              }}
            />
            <TextTheme
              message="Select your recovery option"
              className="text_medium text_dark_blue"
            />
            <br />
            <TextTheme
              message="We will send you an email to reset your password or find your username."
              className="text_small text_black"
            />
            <br />
            <form>
              <div style={{ marginBottom: "20px" }}>
                <Select onChange={this.handleChange} options={options} />
                {this.state.selectedOptionError ? (
                  <div
                    className="invalid-feedback"
                    style={{
                      display: "block",
                      textAlign: "center",
                    }}
                  >
                    {this.state.selectedOptionError}
                  </div>
                ) : null}
              </div>
              <CustomInput
                name="email"
                error={this.state.emailError}
                placeholder="Email"
                handleChange={this.onDataChange.bind(this)}
              />
              <div style={{ width: "100%" }}>
                <div style={{}}>
                  <TextTheme
                    message={this.state.submitMessage}
                    className="text_small text_red"
                  />

                  <RoundedButton
                    title="&nbsp;&nbsp;&nbsp;Submit&nbsp;&nbsp;&nbsp;"
                    buttonClassName="background_dark_orange form_button"
                    textThemeClassName="text_medium text_white"
                    handleOnClick={this.handleSubmit}
                  />
                </div>
              </div>
              <br />
              <br />
            </form>
          </div>
        }
      </div>
    );
  }
}

export default ForgotPassword;
